<template>
  <div>
    <div class="corpo-pagina">
      <div class="row row-text">
        <div class="col s1"></div>
        <div class="col s10">

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.111') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.112') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.113') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.114') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.115') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.116') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.117') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.118') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.119') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.120') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.121') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.122') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.123') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.124') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.125') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.126') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.127') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.128') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.129') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.130') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.133') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.134') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.133.bis') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.134.bis') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.135') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.136') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.137') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.138') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.139') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.140') }}</p>
          </div>

          <div class="questions">
            <h1 class="style color-black">{{ translation('Igotu.141') }}</h1>
            <div class="line"></div>
            <p>{{ translation('Igotu.142') }}</p>
          </div>

        </div>
        <div class="col s1"></div>
      </div>

    </div>

    <div>
      <SignUpFree v-if="!isAuth"/>

    </div>

  </div>
</template>

<script>
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'
import SignUpFree from '@/components/SignUpFree.vue'
import useAuthStore from '@/store/authStore.js'

export default {
  name: 'app',
  data () {
    return {
      translationStore: translationStore,
      useAuthStore: useAuthStore
    }
  },
  components: {
    SignUpFree
  },
  computed: {
    translation () {
      return translationStore.getters.traduzione
    },
    isAuth () {
      return this.useAuthStore.getters.isAuthenticated
    }
  },

  async mounted () {
    loadingStore.commit('setLoading', false)
  },

  methods: {},

  created () {
    loadingStore.commit('setLoading', false)
  }
}
</script>
<style>
h1.style.color-black {
  color: black !important;
  font-size: 2em;
}

.questions {
  width: 100%;
  border-bottom: 1px solid #d5d5d5;
}
</style>
